import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'

import type { CardGridItem, CardGridProps } from './types'

function Card({ title, text, link }: CardGridItem) {
	return (
		<div className="flex flex-col gap-2 rounded-xs bg-brand-100 p-6">
			<h3 className="h4 text-black-950">{title}</h3>
			<p className="body text-black-950">{text}</p>
			{link && (
				<Button variant="link" href={link.url} isExternal={link.isExternal}>
					{link.label}
					{link.isExternal ? (
						<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
					) : (
						<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
					)}
				</Button>
			)}
		</div>
	)
}

export default function CardGrid({ overline, title, cards = [] }: CardGridProps) {
	return (
		<section className="my-16">
			<div className="container">
				<div className="flex flex-col">
					{overline && <p className="body text-black-950">{overline}</p>}
					<h2 className="h3 text-black-950">{title}</h2>
				</div>
				<div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					{cards.map((card, i) => (
						<Card key={i} {...card} />
					))}
				</div>
			</div>
		</section>
	)
}
